/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureSentinel extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureSentinel");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureSentinel.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureSentinel>): ServiceAccountCredentialsForAzureSentinel {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureSentinel(), model);
        ServiceAccountCredentialsForAzureSentinel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureSentinel>): ServiceAccountCredentialsForAzureSentinel {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureSentinel.newInstance(<ServiceAccountCredentialsForAzureSentinel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureSentinel) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureSentinel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureSentinel): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureSentinel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id. This is a required field.
     */
    tenant_id: string;

    /**
     * Application Id. This is a required field.
     */
    application_id: string;

    /**
     * Application Secret. This is a required field.
     */
    application_secret: string;

    /**
     * Workspace Id. This is a required field.
     */
    workspace_id: string;

    /**
     * Shared Key. This is a required field.
     */
    shared_key: string;

}
